import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import TemplateListTable from './TemplateListTable'; // Assuming this will be created
// import TemplateForm from './TemplateForm'; // For later when form is implemented

const AdminTemplatesPage: React.FC = () => {
  // For now, we'll just display the list. Routing/state for form can be added later.
  // const [view, setView] = React.useState<"list" | "form">("list");
  // const [editingTemplate, setEditingTemplate] = React.useState<AnyTemplate | null>(null);

  // const handleCreateNew = () => {
  //   setEditingTemplate(null);
  //   setView("form");
  // };

  // const handleEdit = (template: AnyTemplate) => {
  //   setEditingTemplate(template);
  //   setView("form");
  // };

  // const handleBackToList = () => {
  //   setView("list");
  //   setEditingTemplate(null);
  // };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Admin - Templates Management
        </Typography>
        {/* Add a button to create new template later */}
        {/* <Button variant="contained" onClick={handleCreateNew} sx={{ mb: 2 }}>
          Create New Template
        </Button> */}
      </Paper>

      {/* {view === "list" && <TemplateListTable onEdit={handleEdit} />} */}
      {/* {view === "form" && <TemplateForm template={editingTemplate} onBack={handleBackToList} />} */}
      <TemplateListTable />
    </Box>
  );
};

export default AdminTemplatesPage;
